var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalityUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * { stroke-width: 0px; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NATIONALITY_x5F_UP"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-36",
    className: "st2",
    x: 8.0795,
    y: 9.0798,
    width: 43.841,
    height: 43.841,
    rx: 10,
    ry: 10,
    transform: "translate(-13.13372 30.29298) rotate(-45)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-37",
    className: "st5",
    x: 9.70733,
    y: 8.38637,
    width: 40.58535,
    height: 40.58535,
    rx: 10,
    ry: 10,
    transform: "translate(-11.49234 29.6131) rotate(-45)",
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.98587,16.50021v26.48535c0,.82812.67139,1.5,1.5,1.5s1.5-.67188,1.5-1.5v-15.68555h17.52686c.62891,0,1.19043-.39209,1.40723-.98145.21777-.58984.04395-1.25293-.43457-1.66016l-4.07324-3.4707,4.08496-3.55615c.47266-.41064.63965-1.07129.4209-1.65723-.21973-.58594-.7793-.97412-1.40527-.97412h-19.02686c-.82861,0-1.5.67139-1.5,1.5",
    fill: "#82368c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalityUpIcon);
export default __webpack_public_path__ + "static/media/NationalityUpIcon.8cc99a1eb63aac7a43e7f0a86929334b.svg";
export { ForwardRef as ReactComponent };